var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFf00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.29,30H.71c-.25,0-.48-.13-.61-.34-.13-.21-.14-.47-.03-.7L14.36.36c.24-.48,1.04-.48,1.28,0l14.29,28.6c.11.22.1.49-.03.7-.13.21-.36.34-.61.34Zm-27.42-1.43h26.26L15,2.28,1.87,28.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.7,30.02c-.32,0-.61-.2-.71-.52-.13-.39.09-.82.48-.95,1.19-.38,2.24-1.38,2.83-2.66,1.11-2.45.44-3.43-.26-4.46-.2-.29-.41-.59-.57-.93-.22.42-.42.85-.56,1.14-.34.72-.43.91-.65,1.07-.21.15-.48.18-.72.09-.24-.09-.41-.31-.46-.56-.07-.37-.39-1.44-1-1.99-.9-.8-1.55-2.88-1.32-4.62-1.12,1.42-1.34,4.9-1.42,6.27-.06.9-.07,1.09-.26,1.33-.18.22-.47.33-.75.26-.28-.06-.5-.28-.56-.56-.05-.19-.25-.77-1.13-2.46-.19.34-.41.65-.62.94-.55.76-1.02,1.42-.87,2.37.35,2.23,2,4.15,3.38,4.82.37.18.53.63.35,1-.18.37-.63.53-1,.34-1.77-.86-3.78-3.18-4.21-5.94-.24-1.55.52-2.62,1.13-3.47.6-.84.94-1.36.75-2.11,0-.02-.01-.04-.02-.06-.09-.4.15-.79.55-.89.35-.09.7.08.85.39l.08.14c.38.68.71,1.29.99,1.83.22-2.01.72-4.49,2.06-5.63.59-.5,1.28-.73,2.06-.65.28.03.51.2.62.46s.06.55-.11.76c-.82,1-.3,3.69.45,4.36.36.32.64.71.85,1.1.52-1.05,1.05-1.96,1.63-2.4.24-.19.57-.21.83-.05.26.15.41.45.36.75l-.08.57c-.07.49.17.87.6,1.49.78,1.14,1.86,2.71.39,5.93-.77,1.68-2.12,2.95-3.73,3.47-.08.02-.15.04-.23.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFf00);
export default __webpack_public_path__ + "static/media/FF00.0a71c9e9605f8d5dd6dc5d6b8620ad02.svg";
export { ForwardRef as ReactComponent };